var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGallery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/gallery"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gallery"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.5322 19.0103L3.5121 19.0303C3.24073 18.4403 3.06987 17.7703 2.99951 17.0303C3.06987 17.7603 3.26083 18.4203 3.5322 19.0103Z",
    fill: "#6C6559"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.98485 10.3801C11.306 10.3801 12.3769 9.31456 12.3769 8.00012C12.3769 6.68568 11.306 5.62012 9.98485 5.62012C8.66374 5.62012 7.59277 6.68568 7.59277 8.00012C7.59277 9.31456 8.66374 10.3801 9.98485 10.3801Z",
    fill: "#6C6559"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M17.2113 2H8.78871C5.13023 2 2.94922 4.17 2.94922 7.81V16.19C2.94922 17.28 3.14018 18.23 3.51206 19.03C4.37643 20.93 6.22577 22 8.78871 22H17.2113C20.8697 22 23.0507 19.83 23.0507 16.19V13.9V7.81C23.0507 4.17 20.8697 2 17.2113 2ZM21.4125 12.5C20.6285 11.83 19.3621 11.83 18.5782 12.5L14.397 16.07C13.6131 16.74 12.3467 16.74 11.5627 16.07L11.221 15.79C10.5074 15.17 9.37166 15.11 8.56759 15.65L4.80861 18.16C4.58749 17.6 4.45683 16.95 4.45683 16.19V7.81C4.45683 4.99 5.9544 3.5 8.78871 3.5H17.2113C20.0456 3.5 21.5431 4.99 21.5431 7.81V12.61L21.4125 12.5Z",
    fill: "#6C6559"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGallery);
export default __webpack_public_path__ + "static/media/icon_gallery.5c3fc622191d96be1164b724d02044e9.svg";
export { ForwardRef as ReactComponent };